import MeaPage from "../../../components/MeaPage";
import { useEffect, useRef, useState } from "react";
import trainingsAPI from "../../../services/trainings";
import useAuthContext from "../../../hooks/useAuthContext";
import MeaButton from "../../../components/MeaButton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import tasksAPI from "../../../services/tasks";
import levelsAPI from "../../../services/levels";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ToFormatedDateWithWeekday, ToFormatedHour } from "../../../utils/dates";
import { ProgressBar } from "primereact/progressbar";
import { useParams } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ImportRegistrationsFromExcelFilePage = () => {

    //
    const params = useParams();
    const schoolId = params.schoolId;
    const trainingId = params.registrationId;
    const accessToken = "";
    const [loading, setLoading] = useState(false);
    const [hasLogs, setHasLogs] = useState(false);
    const [logsTitle, setLogsTitle] = useState(null);
    const [logs, setLogs] = useState([]);
    //
    const [file, setFile] = useState(null);
    //
    const [selectedSourceTraining] = useState(null);
    //
    //
    const sourceLevelsQuery = levelsAPI.useGetList(schoolId, selectedSourceTraining, accessToken, 1, 100000);
    const sourceLevels = sourceLevelsQuery?.data?.data;
    //
    //
    const levelsMapping = sourceLevels?.map(level => ({
        "sourceLevelId": level.id,
        "sourceLevelName": level.name,
        "targetLevelFailedId": null,
        "targetLevelFailedName": null,
        "targetLevelPassedId": null,
        "targetLevelPassedName": null
    }));
    //
    const resultsRef = useRef(null);

    const [levelMappings, setLevelMappings] = useState([]);
    useEffect(() => {
        setLevelMappings(levelsMapping);
    }, [sourceLevels]);

    const [selectedCategories, setSelectedCategories] = useState([]);

    const [jobId, setJobId] = useState(null);
    const [jobMode, setJobMode] = useState("indeterminate");
    const [jobProgress, setJobProgress] = useState(-1);

    useEffect(() => {
        if (selectedSourceTraining !== null && selectedSourceTraining !== undefined) {
            trainingsAPI.GetTrainingPreferences(schoolId, trainingId, accessToken).then((data) => {
                const mappings = data?.import_trainings_mappings;
                if (mappings) {
                    const decodedMappings = JSON.parse(atob(mappings));
                    const levelMappings = decodedMappings.find(mapping => mapping.source_training_id === selectedSourceTraining)?.mappings;
                    setLevelMappings(levelMappings);
                };
            });
        }
    }, [selectedSourceTraining]);

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
        }
    };

    const handleImport = () => {
        if (file) {
            setLoading(true);
            setLogsTitle("Importation en élèves...");
            setLogs([]);

            const formData = new FormData();
            formData.append('file', file);
            formData.append("name", file.name);

            fetch(BACKEND_URL + "/api/v1/schools/" + schoolId + "/trainings/" + trainingId + "/tasks/import-registrations-from-excel-file", {
                method: "POST",
                body: formData,
                credentials: "include",
                headers: {
                    Authorization: "Bearer " + accessToken,
                },
            })
                .then((response) => {
                    if (response.status >= 299) {
                        throw new Error(
                            "Erreur de chargement du fichier!"
                        );
                    }
                    return response.json();
                })
                .then((json) => {
                    setJobId(json?.data?.id);
                    setJobMode(json?.data?.progress < 0 ? "indeterminate" : "determinate");
                    setJobProgress(json?.data?.progress);
                    setHasLogs(true);
                })
                .catch(function (error) {
                    console.log("error " + error);
                });
        }

    }

    useEffect(() => {
        const fetchTaskStatus = async () => {
            tasksAPI.GetTask(schoolId, trainingId, jobId, accessToken)
                .then((data) => {
                    setLogsTitle(data?.data?.message);
                    setLogs(data?.data?.job_logs);
                    setJobMode(data?.data?.progress < 0 ? "indeterminate" : "determinate");
                    setJobProgress(data?.data?.progress);
                    if (data?.data?.status === "COMPLETED") {
                        {
                            //setSuccessMessage("Fichier importé avec succès!");
                            //setErrorMessage(null);
                            setLoading(false);
                            setJobId(null);
                        }
                    } else if (data?.data?.status === "FAILED") {
                        {
                            //setSuccessMessage();
                            //setErrorMessage(data?.data?.message);
                            setLoading(false);
                            setJobId(null);
                        }
                    }
                    else {
                        setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
                    }
                })
                .catch((error) => {
                    console.log("error " + error);
                    //setSuccessMessage(null);
                    //setErrorMessage("Erreur de chargement du fichier!");
                    setJobId(null);
                    setLoading(false);
                });
        };

        if (loading && jobId) {
            fetchTaskStatus();
        }

    }, [loading, jobId]);

    return (
        <>
            <MeaPage title="Importer des élèves" subtitle="Importer des élèves depuis un fichier excel">
                <ConfirmDialog />
                <div className="flex flex-column mt-3 p-5 bg-white">
                    <div className="mb-4">Séléctionné le fichier Excel à importer.</div>
                    <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
                        <ul className="list-none p-0 m-0">
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Fichier à importer</div>
                                <div className="text-900 w-full md:w-9">
                                    <input className="" id="file" type="file" onChange={handleFileChange} />
                                </div>
                            </li>

                            <li>
                                <MeaButton label="Importer" disabled={file === undefined || file === null || (hasLogs && !loading)} loading={loading} className="mt-5" onClick={(e) => {
                                    e.stopPropagation();
                                    const mappings = [
                                        {
                                            source_training_id: selectedSourceTraining,
                                            mappings: levelMappings
                                        }
                                    ]
                                    const encodedMappings = btoa(JSON.stringify(mappings));
                                    trainingsAPI.UpdateTrainingPreferences(schoolId, trainingId, accessToken, { import_trainings_mappings: encodedMappings });
                                    confirmDialog({
                                        message:
                                            "Voulez-vous procéder à l'importation des élèves de la formation sélectionnée ?",
                                        header: "Confirmation",
                                        icon: "pi pi-info-circle",
                                        acceptLabel: "Oui",
                                        rejectLabel: "Non",
                                        defaultFocus: "reject",
                                        reject: () => {
                                            setLoading(false);
                                        },
                                        accept: () => {
                                            handleImport();
                                        },
                                    });
                                }}
                                />
                                {hasLogs && !loading && <MeaButton label="Fermer" outlined className="mt-5 ml-3" onClick={() => window.history.back()} />}
                            </li>
                            {hasLogs && <li className="mt-3">
                                {loading && <ProgressBar mode={jobMode} value={jobProgress} style={{ height: '13px' }}></ProgressBar>}
                                <Panel ref={resultsRef} header={logsTitle} toggleable collapsed>
                                    <DataTable value={logs} size="small">
                                        <Column field="log_type" header="Type" body={(item) =>
                                            <span className={item?.log_type === "WARNING" ? "text-orange-500" : (item?.log_type === "ERRR" ? "text-red-500" : "")}>{item?.log_type}</span>
                                        }></Column>
                                        <Column field="message" header="Message" ></Column>
                                        <Column field="created_at" header="Fait le" body={(item) => <>
                                            {ToFormatedDateWithWeekday(new Date(item?.created_at)) + "  " + ToFormatedHour(new Date(item?.created_at))}
                                        </>}></Column>
                                    </DataTable>

                                </Panel>
                            </li>}
                        </ul>
                    </div>

                </div>
            </MeaPage>
        </>
    );
}
export default ImportRegistrationsFromExcelFilePage;
